import React from 'react';

import { base } from 'app/developer-v3/components/PartnerSupportForm/utils/tree';

import Login from './Login';

import { NodeDefinition } from 'app/developer-v3/components/PartnerSupportForm/utils/tree/types';

type NodeOptions = {
  loggedIn: NodeDefinition;
  loggedOut: NodeDefinition;
};

const login = (options: NodeOptions): NodeDefinition => {
  const node = base({
    id: 'login',
    isRequired: false,
    children: {
      loggedIn: options.loggedIn,
      loggedOut: options.loggedOut,
    },
    // always true so that next node always renders
    hasData: () => true,
    getNextNode: (_data, _meta) => {
      return _meta.logged_in ? options.loggedIn : options.loggedOut;
    },
    render: () => {
      return <Login />;
    },
    // don't export
    export: () => null,
  });

  return node;
};

export default login;
